import { Typography } from '@mui/material'

export default function BeheardReportDescription({ children }: any) {
  return (
    <Typography variant='body2' color='text.primary' fontWeight={400} paragraph>
      {children}
    </Typography>
  )
}
